import { render, staticRenderFns } from "./DashInventoryTeam.vue?vue&type=template&id=3bf07e38&scoped=true&"
import script from "./DashInventoryTeam.vue?vue&type=script&lang=js&"
export * from "./DashInventoryTeam.vue?vue&type=script&lang=js&"
import style0 from "./DashInventoryTeam.vue?vue&type=style&index=0&id=3bf07e38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf07e38",
  null
  
)

export default component.exports